import { Injectable } from '@angular/core';
import { StrukturaStore } from '@core/classes/struktura-store.class';
import { FjalaPerzgjedhurStruktura } from '@core/interfaces/models/fjala-perzgjedhur-struktura.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class FjalaPerzgjedhurStrukturaService extends StrukturaStore<FjalaPerzgjedhurStruktura> {

  constructor(apiService: ApiService) {
    super(apiService, 'fjalaPerzgjedhurStruktura');
  }

  updateMy(items: FjalaPerzgjedhurStruktura[]) {
    return this.apiService.put<FjalaPerzgjedhurStruktura[]>(`${this._endpointUrl}my`, { fjalaPerzgjedhurStrukturaForCreationDTO: items });
  }

}
